import { Button } from "@repo/ui";
import { useAuth } from "@stardeck/client-auth";

import { useTestAuthApi } from "@/lib/queries/use-test-auth-api";

export default function AdminDashboard() {
  const { signOut } = useAuth();
  const testApiMutation = useTestAuthApi();

  return (
    <div className="p-6 space-y-4">
      <h1 className="text-2xl font-bold">Admin Dashboard</h1>

      <div className="flex gap-4">
        <Button onClick={() => signOut()}>Sign Out</Button>
        <Button onClick={() => testApiMutation.mutate()} disabled={testApiMutation.isPending}>
          {testApiMutation.isPending ? "Testing..." : "Test Authenticated API"}
        </Button>
      </div>

      {testApiMutation.data && (
        <div className="p-4 bg-gray-100 dark:bg-gray-800 rounded-lg">
          <h3 className="font-semibold mb-2">API Response:</h3>
          <pre className="text-sm overflow-auto">
            {JSON.stringify(testApiMutation.data, null, 2)}
          </pre>
        </div>
      )}

      {testApiMutation.error && (
        <div className="p-4 bg-red-100 dark:bg-red-900 rounded-lg">
          <h3 className="font-semibold mb-2 text-red-800 dark:text-red-200">Error:</h3>
          <pre className="text-sm overflow-auto text-red-700 dark:text-red-300">
            {testApiMutation.error.message}
          </pre>
        </div>
      )}
    </div>
  );
}
